module.exports = __webpack_public_path__ + "img/penguin_engine.28e69773.webp";